import React from 'react'
import { fontSizes } from 'theme'
import { Text } from 'components/Typography'
import { Box } from 'components/Layout'

interface Props {
  isTabletOrMobile: boolean
}

export const SectionTitle: React.FC<Props> = ({ children, isTabletOrMobile }) => (
  <Box mt={isTabletOrMobile ? '1rem' : '2rem'} mb="1rem">
    <Text fontSize={fontSizes.xl}>{children}</Text>
  </Box>
)
